import React from 'react'

const PrivacyPolicy = props => {
  return (
    <div>
      <meta name="Title" content />
      <meta name="Keywords" content />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="Generator" content="Microsoft Word 15 (filtered)" />
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n<!--\n /* Font Definitions */\n@font-face\n\t{font-family:"Cambria Math";\n\tpanose-1:2 4 5 3 5 4 6 3 2 4;}\n@font-face\n\t{font-family:"Arial Unicode MS";\n\tpanose-1:2 11 6 4 2 2 2 2 2 4;}\n@font-face\n\t{font-family:"Helvetica Neue";\n\tpanose-1:2 0 5 3 0 0 0 2 0 4;}\n /* Style Definitions */\np.MsoNormal, li.MsoNormal, div.MsoNormal\n\t{margin:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tborder:none;}\np.MsoDocumentMap, li.MsoDocumentMap, div.MsoDocumentMap\n\t{margin:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tborder:none;}\np.MsoAcetate, li.MsoAcetate, div.MsoAcetate\n\t{margin:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:9.0pt;\n\tfont-family:"Times New Roman",serif;\n\tborder:none;}\np.DocumentTitle, li.DocumentTitle, div.DocumentTitle\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:12.0pt;\n\tmargin-left:0in;\n\ttext-align:center;\n\tfont-size:16.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;\n\tfont-weight:bold;}\np.Paragraph, li.Paragraph, div.Paragraph\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;}\np.Default, li.Default, div.Default\n\t{margin-top:8.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:0in;\n\tmargin-bottom:.0001pt;\n\tfont-size:12.0pt;\n\tfont-family:"Helvetica Neue",sans-serif;\n\tcolor:black;\n\tborder:none;}\np.CustomizableHeading, li.CustomizableHeading, div.CustomizableHeading\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:0in;\n\tmargin-bottom:.0001pt;\n\ttext-align:center;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;\n\tfont-weight:bold;}\np.BulletList1, li.BulletList1, div.BulletList1\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:6.0pt;\n\tmargin-left:0in;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;}\nspan.Hyperlink0\n\t{color:black;\n\tbackground:transparent;\n\tfont-style:none;\n\ttext-decoration:none;}\np.BulletList2, li.BulletList2, div.BulletList2\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:6.0pt;\n\tmargin-left:0in;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;}\np.List-NumberedListLevel1, li.List-NumberedListLevel1, div.List-NumberedListLevel1\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:6.0pt;\n\tmargin-left:0in;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;}\np.ParaFirst-lineIndent, li.ParaFirst-lineIndent, div.ParaFirst-lineIndent\n\t{margin-top:6.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:0in;\n\tmargin-bottom:.0001pt;\n\ttext-indent:.5in;\n\tfont-size:12.0pt;\n\tfont-family:"Times New Roman",serif;\n\tcolor:black;\n\tborder:none;}\nspan.BalloonTextChar\n\t{font-family:"Times New Roman",serif;\n\tborder:none;}\nspan.DocumentMapChar\n\t{font-family:"Times New Roman",serif;\n\tborder:none;}\n.MsoChpDefault\n\t{font-family:"Calibri",sans-serif;}\n@page WordSection1\n\t{size:8.5in 11.0in;\n\tmargin:1.0in 1.0in 1.0in 1.0in;}\ndiv.WordSection1\n\t{page:WordSection1;}\n /* List Definitions */\nol\n\t{margin-bottom:0in;}\nul\n\t{margin-bottom:0in;}\n-->\n'
        }}
      />
      <div className="WordSection1">
        <p className="DocumentTitle">
          <span id="a540548">Zoodiker Privacy Notice for California Residents</span>
        </p>
        <p className="Paragraph">
          <b>Effective Date:</b> 18 July 2020
          <br />
          <br />
        </p>
        <p className="Paragraph">
          [<b>Last Reviewed on</b>: 18 July 2020]
        </p>
        <p className="Paragraph">
          This <b>Privacy Notice for California Residents</b>
          supplements the information contained in Zoodiker's{' '}
          <span style={{ background: 'transparent' }}>[HYPERLINKED URL TO GENERAL PRIVACY NOTICE]</span> and applies
          solely to all visitors, users, and others who reside in the State of California ("<b>you</b>"). We adopt this
          notice to comply with the California Consumer Privacy Act of 2018 (CCPA).{' '}
        </p>
        <p className="Paragraph">
          Any terms defined in the CCPA have the same meaning when used in this Notice. Any term in bold has the meaning
          ascribed in this policy or in Zoodiker’s Terms of Use.
        </p>
        <p className="CustomizableHeading">
          <span id="a871356">
            <u>
              <span style={{ textDecoration: 'none' }}>&nbsp;</span>
            </u>
          </span>
        </p>
        <p className="CustomizableHeading">
          <u>Information We Collect</u>
        </p>
        <p className="Paragraph">
          Our <b>Website</b> collects information that identifies, relates to, describes, references, is reasonably
          capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular
          consumer, household, or device ("<b>personal information</b>"). Personal information does not include:
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          Publicly available information from government records.
          <br />
          <br />
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          Deidentified or aggregated consumer information.
        </p>
        <p className="Paragraph">
          In particular, our Website collects the following categories of personal information:{' '}
        </p>
        <p className="Paragraph">&nbsp;</p>
        <table
          className="MsoNormalTable"
          border={1}
          cellSpacing={0}
          cellPadding={0}
          width={469}
          style={{ marginLeft: '.15in', background: '#CED7E7', borderCollapse: 'collapse', border: 'none' }}
        >
          <tbody>
            <tr style={{ height: '15.5pt' }}>
              <td
                width={140}
                valign="top"
                style={{
                  width: '1.95in',
                  border: 'solid black 1.0pt',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '15.5pt'
                }}
              >
                <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
                  <b>Category</b>
                </p>
              </td>
              <td
                width={329}
                valign="top"
                style={{
                  width: '328.55pt',
                  border: 'solid black 1.0pt',
                  borderLeft: 'none',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '15.5pt'
                }}
              >
                <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
                  <b>Examples</b>
                </p>
              </td>
            </tr>
            <tr style={{ height: '15.5pt' }}>
              <td
                width={140}
                valign="top"
                style={{
                  width: '1.95in',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '15.5pt'
                }}
              >
                <p className="Paragraph">A. Identifiers.</p>
              </td>
              <td
                width={329}
                valign="top"
                style={{
                  width: '328.55pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '15.5pt'
                }}
              >
                <p className="Paragraph">A real name, Internet Protocol address, email address.</p>
              </td>
            </tr>
            <tr style={{ height: '81.5pt' }}>
              <td
                width={140}
                valign="top"
                style={{
                  width: '1.95in',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '81.5pt'
                }}
              >
                <p className="Paragraph">
                  B. Personal information categories listed in the California Customer Records statute{' '}
                </p>
              </td>
              <td
                width={329}
                valign="top"
                style={{
                  width: '328.55pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '81.5pt'
                }}
              >
                <p className="Paragraph">
                  A name, telephone number, education, employment, bank account number, credit card number, debit card
                  number, or any other financial information.
                </p>
                <p className="Paragraph">
                  Some personal information included in this category may overlap with other categories.
                </p>
              </td>
            </tr>
            <tr style={{ height: '66.5pt' }}>
              <td
                width={140}
                valign="top"
                style={{
                  width: '1.95in',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '66.5pt'
                }}
              >
                <p className="Paragraph">
                  C. Protected classification characteristics under California or federal law.
                </p>
              </td>
              <td
                width={329}
                valign="top"
                style={{
                  width: '328.55pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '66.5pt'
                }}
              >
                <p className="Paragraph">
                  Age, race, color, ancestry, national origin, citizenship, religion or creed, marital status, sex
                  (including gender, gender identity, gender expression, sexual orientation.
                </p>
              </td>
            </tr>
            <tr style={{ height: '30.5pt' }}>
              <td
                width={140}
                valign="top"
                style={{
                  width: '1.95in',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '30.5pt'
                }}
              >
                <p className="Paragraph">D. Internet or other similar network activity.</p>
              </td>
              <td
                width={329}
                valign="top"
                style={{
                  width: '328.55pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '30.5pt'
                }}
              >
                <p className="Paragraph">
                  Browsing history, search history, information on a consumer's interaction with a website, application,
                  or advertisement.
                </p>
              </td>
            </tr>
            <tr style={{ height: '45.5pt' }}>
              <td
                width={140}
                valign="top"
                style={{
                  width: '1.95in',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '45.5pt'
                }}
              >
                <p className="Paragraph">E. Professional or employment-related information.</p>
              </td>
              <td
                width={329}
                valign="top"
                style={{
                  width: '328.55pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '45.5pt'
                }}
              >
                <p className="Paragraph">Current job.</p>
              </td>
            </tr>
            <tr style={{ height: '45.5pt' }}>
              <td
                width={140}
                valign="top"
                style={{
                  width: '1.95in',
                  border: 'solid black 1.0pt',
                  borderTop: 'none',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '45.5pt'
                }}
              >
                <p className="Paragraph">F. Inferences drawn from other personal information.</p>
              </td>
              <td
                width={329}
                valign="top"
                style={{
                  width: '328.55pt',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderBottom: 'solid black 1.0pt',
                  borderRight: 'solid black 1.0pt',
                  background: 'transparent',
                  padding: '4.0pt 4.0pt 4.0pt 4.0pt',
                  height: '45.5pt'
                }}
              >
                <p className="Paragraph">
                  Profile reflecting a person's preferences, characteristics, psychological trends, predispositions,
                  behavior, attitudes, abilities, and aptitudes.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="Paragraph" style={{ marginLeft: '5.4pt', textIndent: '-5.4pt' }}>
          &nbsp;
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="Paragraph">
          Our Website obtains the categories of personal information listed above from the following categories of
          sources:
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          Directly from you. For example, from forms you complete or products and services you purchase.
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          Indirectly from you. For example, from observing your actions on our Website.
        </p>
        <p className="CustomizableHeading">
          <span id="a748479">
            <u>
              <br />
              <br />
            </u>
          </span>
        </p>
        <p className="CustomizableHeading">
          <u>Use of Personal Information</u>
        </p>
        <p className="Paragraph">
          We may use or disclose the personal information we collect for one or more of the following purposes:{' '}
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          To fulfill or meet the reason you provided the information. For example, if you provide your personal
          information to purchase a subscription with us, we will use that information to process your payment and
          facilitate delivery. We may also save your information to facilitate orders or process returns.{' '}
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          To provide, support, personalize, and develop our Website, products, and services.
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          To create, maintain, customize, and secure your account with us.
          <br />
          <br />
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          To process your requests, purchases, transactions, and payments.
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          To provide you with support and to respond to your inquiries, including to investigate and address your
          concerns and monitor and improve our responses.
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          To help maintain the safety, security, and integrity of our Website, products and services, databases and
          other technology assets, and business.
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          For testing, research, analysis, and product development, including to develop and improve our Website,
          products, and services.
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          To respond to law enforcement requests and as required by applicable law, court order, or governmental
          regulations.
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          As described to you when collecting your personal information or as otherwise set forth in the CCPA.
        </p>
        <p className="Paragraph">
          We will not collect additional categories of personal information or use the personal information we collected
          for materially different, unrelated, or incompatible purposes without providing you notice.
        </p>
        <p className="CustomizableHeading">
          <span id="a831891">
            <u>Personal Information</u>
          </span>
          <u>Shared With Service Providers Only To Process Payment</u>
        </p>
        <p className="Paragraph">
          We may disclose your personal information to a third party solely to process your purchases, transactions, and
          payments with our service providers.&nbsp;{' '}
        </p>
        <p className="CustomizableHeading">
          <u>Personal Information Shared With Third Parties After De-Personalizing</u>
        </p>
        <p className="Paragraph" align="center" style={{ textAlign: 'center' }}>
          <b>
            <u>
              <span style={{ textDecoration: 'none' }}>&nbsp;</span>
            </u>
          </b>
        </p>
        <p className="BulletList1">&nbsp;</p>
        <p className="BulletList1">
          Zoodiker may process your personal information in deidentified and/or pseudonymized form and compile the
          results in aggregated form to develop <b>User Analytics</b>.&nbsp; The <b>User Analytics</b> may be be shared
          and sold to third parties without restriction.
        </p>
        <p className="BulletList1">
          To emphasize, any disclosure or sale of your personal information will only be in deidentified, pseudonymized,
          and/or aggregated form.&nbsp;{' '}
        </p>
        <p className="CustomizableHeading">
          <span id="a363591">
            <u>Your Rights and Choices </u>
          </span>
        </p>
        <p className="Paragraph">
          The CCPA provides consumers (California residents) with specific rights regarding their personal information.
          This section describes your CCPA rights and explains how to exercise those rights.
        </p>
        <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
          <span id="a828717">
            <i>Access to Specific Information and Data Portability Rights</i>
          </span>
        </p>
        <p className="Paragraph">
          You have the right to request that we disclose certain information to you about our collection and use of your
          personal information over the past 12 months. Once we receive and confirm your verifiable consumer request
          (see{' '}
          <span className="Hyperlink0">
            <span style={{ color: 'black' }}>
              <a href="#a585939">
                <span style={{ color: 'black', textDecoration: 'none' }}>
                  <span style={{ color: 'black' }}>Exercising Access, Data Portability, and Deletion Rights</span>
                </span>
              </a>
            </span>
          </span>
          <span className="None">
            ), we will disclose to you:
            <br />
            <br />
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            The categories of personal information we collected about you.
            <br />
            <br />
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            The categories of sources for the personal information we collected about you.
            <br />
            <br />
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            Our business or commercial purpose for collecting or selling that personal information.
            <br />
            <br />
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            The categories of third parties with whom we share that personal information.
            <br />
            <br />
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            The specific pieces of personal information we collected about you (also called a data portability request).
            <br />
            <br />
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            If we sold or disclosed your personal information for a business purpose, two separate lists disclosing:
          </span>
        </p>
        <p className="BulletList2" style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            sales, identifying the personal information categories that each category of recipient purchased; and{' '}
          </span>
        </p>
        <p className="BulletList2" style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            disclosures for a business purpose, identifying the personal information categories that each category of
            recipient obtained.{' '}
          </span>
        </p>
        <p className="Paragraph">&nbsp;</p>
        <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
          <span id="a664478">
            <span className="None">
              <i>Deletion Request Rights </i>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            You have the right to request that we delete any of your personal information that we collected from you and
            retained, subject to certain exceptions. However, the only purposes for which we collect your personal
            information are exceptions to your deletion requests.&nbsp; Notably, the purposes for which we collect and
            retain your personal information are to:{' '}
          </span>
        </p>
        <p className="List-NumberedListLevel1" style={{ marginLeft: '.5in', textIndent: '-.3in' }}>
          1.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <span className="None">
            Complete the transaction for which we collected the personal information, provide access to Zoodiker.
          </span>
        </p>
        <p className="List-NumberedListLevel1" style={{ marginLeft: '.5in', textIndent: '-.3in' }}>
          2.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <span className="None">
            Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or
            prosecute those responsible for such activities.
          </span>
        </p>
        <p className="List-NumberedListLevel1" style={{ marginLeft: '.5in', textIndent: '-.3in' }}>
          3.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <span className="None">
            Debug products to identify and repair errors that impair existing intended functionality.
          </span>
        </p>
        <p className="List-NumberedListLevel1" style={{ marginLeft: '.5in', textIndent: '-.3in' }}>
          4.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <span className="None">
            Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or exercise
            another right provided for by law.
          </span>
        </p>
        <p className="List-NumberedListLevel1" style={{ marginLeft: '.5in', textIndent: '-.3in' }}>
          5.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <span className="None">
            Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 <i>et. seq.</i>).
          </span>
        </p>
        <p className="List-NumberedListLevel1" style={{ marginLeft: '.5in', textIndent: '-.3in' }}>
          6.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <span className="None">
            Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest
            that adheres to all other applicable ethics and privacy laws, when the information's deletion may likely
            render impossible or seriously impair the research's achievement, if you previously provided informed
            consent.
          </span>
        </p>
        <p className="List-NumberedListLevel1" style={{ marginLeft: '.5in', textIndent: '-.3in' }}>
          7.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <span className="None">
            Enable solely internal uses that are reasonably aligned with consumer expectations based on your
            relationship with us.
          </span>
        </p>
        <p className="List-NumberedListLevel1" style={{ marginLeft: '.5in', textIndent: '-.3in' }}>
          8.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <span className="None">
            Comply with a legal obligation.
            <br />
            <br />
          </span>
        </p>
        <p className="List-NumberedListLevel1" style={{ marginLeft: '.5in', textIndent: '-.3in' }}>
          9.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <span className="None">
            Make other internal and lawful uses of that information that are compatible with the context in which you
            provided it.
          </span>
        </p>
        <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
          <span id="a585939">
            <span className="None">
              <i>Exercising Access, Data Portability, and Deletion Rights</i>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            To exercise the access, data portability, and deletion rights described above, please submit a verifiable
            consumer request to us by either: <br />
            <br />
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">[Calling us at [TOLL-FREE NUMBER].]</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">[Emailing us at [EMAIL ADDRESS].]</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">[Visiting [WEBSITE ADDRESS].]</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">[[PASSWORD PROTECTED ACCOUNT INSTRUCTIONS].]</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">[[OTHER METHOD].] </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            Only you, or someone legally authorized to act on your behalf, may make a verifiable consumer request
            related to your personal information.{' '}
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            You may only make a verifiable consumer request for access or data portability twice within a 12-month
            period. The verifiable consumer request must:
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            Provide sufficient information that allows us to reasonably verify you are the person about whom we
            collected personal information or an authorized representative, which may include:
            <br />
            <br />
          </span>
        </p>
        <p className="BulletList2" style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">Your Zoodiker user name.</span>
        </p>
        <p className="BulletList2" style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">The name under which you furnished your payment information.</span>
        </p>
        <p className="BulletList2" style={{ marginLeft: '.75in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">[VERIFICATION REQUIREMENTS].</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            Describe your request with sufficient detail that allows us to properly understand, evaluate, and respond to
            it.
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            We cannot respond to your request or provide you with personal information if we cannot verify your identity
            or authority to make the request and confirm the personal information relates to you.{' '}
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            We will only use personal information provided in a verifiable consumer request to verify the requestor's
            identity or authority to make the request.{' '}
          </span>
        </p>
        <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
          <span id="a736729">
            <span className="None">
              <i>Response Timing and Format</i>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            We endeavor to respond to a verifiable consumer request within forty-five (45) days of its receipt. If we
            require more time (up to 45 days), we will inform you of the reason and extension period in writing.
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            If you have an account with us, we will deliver our written response to that account. If you do not have an
            account with us, we will deliver our written response by mail or electronically, at your option.{' '}
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            Any disclosures we provide will only cover the 12-month period preceding the verifiable consumer request's
            receipt. The response we provide will also explain the reasons we cannot comply with a request, if
            applicable. <br />
            <br />
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            We do not charge a fee to process or respond to your verifiable consumer request unless it is excessive,
            repetitive, or manifestly unfounded. If we determine that the request warrants a fee, we will tell you why
            we made that decision and provide you with a cost estimate before completing your request.{' '}
          </span>
        </p>
        <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
          <span id="a794300">
            <span className="None">
              <i>Personal Information Sales Opt-Out and Opt-In Rights</i>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">Zoodiker does not sell your personal information. </span>
        </p>
        <p className="CustomizableHeading">
          <span id="a130584">
            <span className="None">
              <u>Non-Discrimination</u>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA,
            we will not:
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">Deny you goods or services.</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            Charge you different prices or rates for goods or services, including through granting discounts or other
            benefits, or imposing penalties.
          </span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">Provide you a different level or quality of goods or services.</span>
        </p>
        <p className="BulletList1" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span style={{ fontFamily: 'Symbol' }}>
            ·<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </span>
          <span className="None">
            Suggest that you may receive a different price or rate for goods or services or a different level or quality
            of goods or services.
          </span>
        </p>
        <p className="CustomizableHeading">
          <span id="a545195">
            <span className="None">
              <u>Changes to Our Privacy Notice</u>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            We reserve the right to amend this privacy notice at our discretion and at any time. When we make changes to
            this privacy notice, we will post the updated notice on the Website and update the notice's effective date.{' '}
            <b>
              Your continued use of our Website following the posting of changes constitutes your acceptance of such
              changes
            </b>
            .
          </span>
        </p>
        <p className="CustomizableHeading">
          <span id="a953370">
            <span className="None">
              <u>Contact Information</u>
            </span>
          </span>
        </p>
        <p className="Paragraph">
          <span className="None">
            If you have any questions or comments about this notice, the ways in which Zoodiker collects and uses your
            information described here [and in the{' '}
            <b>
              <u>Privacy Policy</u>
            </b>
            ], your choices and rights regarding such use, or wish to exercise your rights under California law, please
            do not hesitate to contact us at:
          </span>
        </p>
        <p className="ParaFirst-lineIndent">
          <span className="None">
            <b>Phone</b>: [TOLL-FREE PHONE NUMBER]
          </span>
        </p>
        <p className="ParaFirst-lineIndent">
          <span className="None">
            <b>Website</b>: [WEBSITE CONTACT URL]
          </span>
        </p>
        <p className="ParaFirst-lineIndent">
          <span className="None">
            <b>Email</b>: [EMAIL ADDRESS]
          </span>
        </p>
        <p className="ParaFirst-lineIndent">
          <span className="None">
            <b>Postal Address</b>:{' '}
          </span>
        </p>
        <p className="ParaFirst-lineIndent">
          <span className="None">Zoodiker</span>
        </p>
        <p className="ParaFirst-lineIndent">
          <span className="None">Attn: [CONTACT NAME/DEPARTMENT]</span>
        </p>
        <p className="ParaFirst-lineIndent">
          <span className="None">[PHYSICAL ADDRESS]</span>
        </p>
        <p className="ParaFirst-lineIndent">
          <span className="None">[[OTHER CONTACT METHOD]: [CONTACT INSTRUCTIONS]]</span>
        </p>
        <p className="MsoNormal">&nbsp;</p>
      </div>
    </div>
  )
}

export default PrivacyPolicy
